<template>
  <b-modal
    id="document-request-modal"
    size="lg"
    :title="$t('application.documentModal.title')"
    :no-close-on-backdrop="true"
    cancel-variant="outline-secondary"
    :cancel-title="$t('application.documentModal.cancelTitle')"
    :ok-disabled="documentList.length === 0"
    :ok-title="$t('application.documentModal.okTitle')"
    scrollable
    @shown="resetForm"
    @ok="handleSendDocumentRequest"
  >
    <b-row>
      <b-col cols="9">
        <b-form-input
          ref="documentNameRef"
          v-model.trim="documentName"
          :placeholder="$t('application.documentModal.documentNamePlaceholder')"
          @keydown.enter="handleAddDocumentList"
        />
      </b-col>

      <b-col cols="3">
        <b-button
          variant="outline-primary"
          :disabled="!documentName"
          block
          @click="handleAddDocumentList"
        >
          {{ $t('application.documentModal.addBtn') }}
          <feather-icon icon="PlusIcon" class="mr-50" />
        </b-button>
      </b-col>
    </b-row>
    <hr />
    <b-list-group v-if="documentList.length > 0">
      <b-list-group-item
        v-for="(doc, index) in documentList"
        :key="index"
        class="d-flex justify-content-between align-items-center"
      >
        <b class="text-capitalize">
          {{ doc }}
        </b>
        <b-button variant="outline-danger" size="sm" @click="handleRemoveTodoItem(index)">
          <feather-icon icon="XIcon" size="18" />
        </b-button>
      </b-list-group-item>
    </b-list-group>
  </b-modal>
</template>

<script>
import {
  BButton,
  BFormInput,
  BModal,
  BRow,
  BCol,
  BListGroup,
  BListGroupItem,
  VBModal,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BFormInput,
    BModal,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    userData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      documentName: '',
      documentList: [],
    }
  },
  created() {
    if (this.userData && !this.userData.hasValvira && this.userData.profession !== 'opiskelija') {
      this.documentList.push('Tutkintotodistus')
    }
    if (this.userData && this.userData.love) {
      this.documentList.push('Lääkehoitolupa (teoria ja laskut)')
    }
    if (this.userData && this.userData.profession === 'opiskelija') {
      this.documentList.push('Opintosuoritusote')
      this.documentList.push('Läsnäolotodistus')
    }
  },
  methods: {
    handleAddDocumentList() {
      if (!this.documentName) return
      this.documentList.push(this.documentName)
      this.documentName = ''
      this.$refs.documentNameRef.focus()
    },
    handleRemoveTodoItem(index) {
      this.documentList.splice(index, 1)
    },
    handleSendDocumentRequest() {
      this.$emit('create-document-request', this.documentList)
      this.resetForm()
    },
    resetForm() {
      this.documentName = ''
      this.documentList = []
      if (this.userData && !this.userData.hasValvira && this.userData.profession !== 'opiskelija') {
        this.documentList.push('Tutkintotodistus')
      }
      if (this.userData && this.userData.love) {
        this.documentList.push('Lääkehoitolupa (teoria ja laskut)')
      }
      if (this.userData && this.userData.profession === 'opiskelija') {
        this.documentList.push('Opintosuoritusote')
        this.documentList.push('Läsnäolotodistus')
      }
    },
  },
}
</script>

<style></style>
